import { useState } from "react";
import { Dices, FastForward, Flag, Pause, Play, Plus, RotateCw, SkipForward, Square, StepForward, Timer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ConfirmDialog } from "@/components/ConfirmDialog";

const Btn = ({ icon: Icon, children, primary, ...p }) => (
  <Button {...p} className={`h-12 px-4 text-base font-bold ${primary ? "" : "border border-slate-700/60 bg-white/5 backdrop-blur-md text-white hover:bg-white/10 hover:border-[#FACC15]/60 hover:shadow-[0_0_14px_rgba(250,204,21,0.25)] hover:scale-[1.03]"}`}>
    <Icon className="h-5 w-5 mr-2" />{children}
  </Button>
);

const STATUS = { played: "✓", skipped: "atlandı", new: "" };

export const ControlBar = ({ state, send, big = false }) => {
  const [confirm, setConfirm] = useState(null);
  if (!state) return null;
  const { phase, paused } = state;
  const cmd = (action, extra = {}) => send({ type: "cmd", action, ...extra });
  const open = phase === "question";
  const ask = (title, description, confirmText, run) => setConfirm({ title, description, confirmText, run });

  return (
    <div className={`flex flex-wrap items-center gap-2 ${big ? "justify-center" : ""}`} data-testid="control-bar">
      {phase === "lobby" && <Btn icon={Play} primary onClick={() => cmd("start")} data-testid="ctrl-start">Başlat</Btn>}
      {phase !== "finished" && phase !== "lobby" && (paused
        ? <Btn icon={Play} primary onClick={() => cmd("resume")} data-testid="ctrl-resume">Devam et</Btn>
        : <Btn icon={Pause} onClick={() => cmd("pause")} data-testid="ctrl-pause">Duraklat</Btn>)}
      {phase === "wheel" && <Btn icon={RotateCw} primary disabled={state.spin?.pending || paused} onClick={() => cmd("spin")} data-testid="ctrl-spin">Çarkı çevir</Btn>}
      {phase === "activity" && state.mode === "boardsort" && <Btn icon={SkipForward} disabled={paused} onClick={() => cmd("pass_turn")} data-testid="ctrl-pass-turn">Sırayı geç</Btn>}
      {phase === "activity" && state.mode === "bingo" && <Btn icon={Dices} primary disabled={paused || state.drawn_count >= state.item_count} onClick={() => cmd("draw")} data-testid="ctrl-draw">İpucu çek</Btn>}
      {phase === "activity" && state.mode === "bingo" && (
        <Btn icon={Timer} disabled={!state.auto_draw && state.drawn_count >= state.item_count} onClick={() => cmd("toggle_auto")} data-testid="ctrl-auto-draw">
          {state.auto_draw ? "Otomatik çekilişi durdur" : `Otomatik çekiliş (${state.settings?.auto_draw_interval} sn)`}
        </Btn>
      )}
      {phase === "activity" && state.total_ms > 0 && <Btn icon={Plus} onClick={() => cmd("extend")} data-testid="ctrl-extend-activity">10 sn</Btn>}
      {open && <Btn icon={Square} onClick={() => cmd("end_question")} data-testid="ctrl-end-question">Soruyu bitir</Btn>}
      {open && <Btn icon={Plus} onClick={() => cmd("extend")} data-testid="ctrl-extend">10 sn</Btn>}
      {open && <Btn icon={SkipForward} onClick={() => ask("Soru atlansın mı?", "Soru puansız iptal edilir; kimseye puan veya yanıtsız kaydı yazılmaz.", "Atla", () => cmd("skip"))} data-testid="ctrl-skip">Soruyu atla</Btn>}
      {(open || phase === "results") && (
        <Btn icon={StepForward} primary={!open} data-testid="ctrl-next"
          onClick={() => (open ? ask("Soru açık, atlansın mı?", "Açık soru puansız atlanıp sonraki soruya geçilecek.", "Atla ve geç", () => cmd("next", { force: true })) : cmd("next"))}>
          Sonraki soru
        </Btn>
      )}
      {phase !== "finished" && state.question_list?.length > 0 && (
        <Select value="" onValueChange={(qid) => (open ? ask("Soru açık, atlansın mı?", "Açık soru puansız atlanıp seçilen soruya geçilecek.", "Geç", () => cmd("goto", { question_id: qid })) : cmd("goto", { question_id: qid }))}>
          <SelectTrigger className="h-12 w-44 font-bold" data-testid="ctrl-goto"><FastForward className="h-5 w-5 mr-1" /><SelectValue placeholder="Soruya git" /></SelectTrigger>
          <SelectContent>
            {state.question_list.map((q) => (
              <SelectItem key={q.id} value={q.id}>{q.n}. {q.text.slice(0, 50)} · {q.points}p {STATUS[q.status]}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      {phase !== "finished" && phase !== "lobby" && (
        <Btn icon={Flag} onClick={() => ask("Oyun bitirilsin mi?", "Oyun sonlandırılır ve sonuç ekranına geçilir.", "Oyunu bitir", () => cmd("end_game"))} data-testid="ctrl-end-game">Oyunu bitir</Btn>
      )}
      <ConfirmDialog open={Boolean(confirm)} onOpenChange={(o) => !o && setConfirm(null)} title={confirm?.title}
        description={confirm?.description} confirmText={confirm?.confirmText} onConfirm={() => { confirm.run(); setConfirm(null); }} />
    </div>
  );
};
